import { useContext } from "react";
import { useSelector } from "react-redux";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import { useResource } from "../../../Hooks/UseResource";
import { useWidgetService } from "../../Widgets/WidgetManager/UseWidgetService";
import {
  getHolderData,
  getWidgetDTOList,
} from "../../../Store/WidgetDataSelector";
import { SessionKeyEnum } from "../../../Enumeration/SessionKeyEnum";

function VideoKycResource() {
  const {updateWidgetDTOToStore} = useWidgetService();
  const [resourceError, loading, getData, postData] = useResource();
  const applicationContext = useContext(KycApplicationContext);
  const currentHolder = applicationContext.currentHolder;
  const holderData = useSelector((state) =>
    getHolderData(state, currentHolder ? currentHolder.entityTypeShortName : "")
  );

  let widgetList = useSelector((state) =>
    getWidgetDTOList(
      state,
      currentHolder ? currentHolder.entityTypeShortName : ""
    )
  );

  const videoKycCreateProfile = (videoKycCreateProfileDTO) => {
    return postData({
      url: "public/video-kyc-create-profile",
      data: videoKycCreateProfileDTO
    });
  };


  const videoKycProfileStatus = (profileId, holderType, kycSessionToken) => {
    return postData({
      url: "public/video-kyc-profile-status",
      data: {
        profileId: profileId,
        holderType: holderType,
        appKey: kycSessionToken,
      },
    });
  };

  const updateWidgetStatus = (kycAppWidgetDTO) => {
    updateWidgetDTOToStore(
      holderData,
      currentHolder,
      widgetList,
      kycAppWidgetDTO.widgetDTO,
      kycAppWidgetDTO.isKycProcessCompleted
    );
  };

  const validateDateForVideoKyc = (kycApplicationId, holderType) => {
    return postData({
      url: "public/validate-date-video-kyc",
      data: {
        kycApplicationId: kycApplicationId,
        holderType: holderType,
      },
    });
  };

  const removePersonalInfoData = (kycApplicationId, holderType) => {
    return postData({
      url: "public/remove-personal-info-data",
      data: {
        kycApplicationId: kycApplicationId,
        holderType: holderType,
        appKey : sessionStorage.getItem(SessionKeyEnum.AppKey),
        encryptedMode :sessionStorage.getItem(SessionKeyEnum.EncryptedMode)
      },
    });
  };



  return [videoKycCreateProfile, videoKycProfileStatus,updateWidgetStatus,validateDateForVideoKyc,removePersonalInfoData];
}

export default VideoKycResource;
